import { provideAppDestroy, type AppDestroy } from '@bcf-vanilla-ts-v1-shared/di/app-destroy';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { BehaviorSubject, filter, first, mapTo, skip, takeUntil, type Observable } from 'rxjs';
import {
  provideModalStandaloneResolverSignalService,
  type ModalStandaloneResolverSignalService
} from './modal-standalone-resolver-signal.service';

export class ModalErrorService {
  public show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public message$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>('');
  public messageHtml$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>('');
  public title$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  constructor(
    private _modalStandaloneResolverSignal: ModalStandaloneResolverSignalService,
    private _appDestroy: AppDestroy
  ) {
    this._init();
  }

  private _init(): void {
    this.show$
      .pipe(takeUntil(this._appDestroy.destroy$))
      .subscribe(this._modalStandaloneResolverSignal.resolve('error'));
    this.show$
      .pipe(
        filter((show: boolean) => show === false),
        takeUntil(this._appDestroy.destroy$)
      )
      .subscribe(() => {
        this.message$.next(undefined);
        this.messageHtml$.next(undefined);
      });
  }

  public doOnClose(): Observable<void> {
    return this.show$.pipe(
      skip(1),
      first((state: boolean) => state === false),
      mapTo(undefined)
    );
  }
}

export function provideModalErrorService(): ModalErrorService {
  return provideSingleton(
    ModalErrorService,
    () => new ModalErrorService(provideModalStandaloneResolverSignalService(), provideAppDestroy())
  );
}
